import React, { Suspense, useState } from "react";
import { FiShare2 } from "react-icons/fi";
import { Modal } from "./Modal";
import { LoadingSpinner } from "./LoadingSpinner";

// The whole-site connection graph is heavy (@xyflow/react + the full graph). Load it lazily so it
// only costs anything when an editor actually opens the modal.
const ConnectionsGraph = React.lazy(() => import("../Pages/ConnectionsGraph"));

/**
 * A button that opens the whole-site page-connections graph in a modal. Lives next to the
 * preview/prod link controls on the Content and Deployment pages so an editor can inspect how
 * pages link to each other without leaving their workflow.
 */
const ConnectionsModalButton: React.FC<{ className?: string; label?: string }> = ({
	className,
	label = "Connexions"
}) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className={
					className ??
					"inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium text-foreground hover:bg-muted"
				}
				title="Voir le graphe des connexions entre pages"
			>
				<FiShare2 className="h-4 w-4" /> {label}
			</button>
			<Modal show={open} onHide={() => setOpen(false)} size="full85" centered dialogClassName="min-h-[80vh]">
				<Modal.Header closeButton>
					<Modal.Title className="text-lg font-semibold text-foreground">Connexions entre les pages</Modal.Title>
				</Modal.Header>
				<Modal.Body className="flex min-h-0 flex-col bg-muted/30">
					{open && (
						<Suspense
							fallback={
								<div className="flex flex-1 items-center justify-center p-10">
									<LoadingSpinner size="lg" />
								</div>
							}
						>
							<ConnectionsGraph embedded />
						</Suspense>
					)}
				</Modal.Body>
			</Modal>
		</>
	);
};

export default ConnectionsModalButton;
